import type { Kpi } from "@/mock";

const compact = new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 });
const plain = new Intl.NumberFormat("en-US");

export function fmt(n: number): string {
  return Math.abs(n) >= 10000 ? compact.format(n) : plain.format(n);
}

export function formatKpi(value: number, unit?: Kpi["unit"]): string {
  switch (unit) {
    case "pct":
      return `${value}%`;
    case "sec":
      return value >= 60 ? `${Math.floor(value / 60)}m ${value % 60}s` : `${value}s`;
    case "money":
      return `$${fmt(value)}`;
    default:
      return fmt(value);
  }
}

export function formatDelta(d: number): string {
  const s = d > 0 ? "+" : d < 0 ? "−" : "";
  return `${s}${Math.abs(d).toFixed(1)}%`;
}
